import Vue from 'vue';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
import moment from 'vue-moment';
import VueObserveVisibility from 'vue-observe-visibility';
import VueVirtualScroller from 'vue-virtual-scroller';
import Vuetify from 'vuetify/lib';
import ScrollSync from 'vue-scroll-sync';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import '@fortawesome/fontawesome-pro/css/all.css';
import { mdiRadioboxMarked } from '@mdi/js';
import { mdiRadioboxBlank } from '@mdi/js';

Vue.use(Vuetify);
Vue.use(VueLodash, { lodash: lodash });
Vue.use(moment);
Vue.use(VueObserveVisibility);
Vue.use(VueVirtualScroller);
Vue.use(ScrollSync);
Vue.component('scroll-sync', ScrollSync);

export default new Vuetify({
  icons: {
    iconfont: 'fa',
    values: {
      radioOn: mdiRadioboxMarked,
      radioOff: mdiRadioboxBlank,
    }
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#1976D2',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#31bd6b',
        warning: {
          base: '#c25400',
          lighten1: '#feb57f'
        },
        resGrey: {
          darken2: "#4f4f4f",
          darken1: "#7a7a7a",
          base: "#a6a6a6",
          lighten1: "#d1d1d1",
          lighten2: "#e2e2e2",
          lighten3: "#e8e8e8",
          lighten4: "#f2f2f2",
        },
        resBlue: {
          darken2: "#005675",
          darken1: "#03739c",
          base: "#0891c2",
          lighten1: "#35afdb",
          lighten2: "#6cd0f5",
          lighten3: "#e9f9fd",
        },
        resRed: {
          darken2: "#850111",
          darken1: "#ab0215",
          base: "#d0021b",
          lighten1: "#de3c23",
          lighten2: "#eb5e49",
          lighten4: "#fbf1f8"
        },
        resOrange: {
          darken2: "#e68609",
          darken1: "#f29d2e",
          base: "#ffc356",
          lighten1: "#ffd17d",
          lighten2: "#ffda96"
        },
        resGreen: {
          darken2: "#375400",
          darken1: '#476e00',
          base: "#5f9400",
          lighten1: '#83ba1c',
          lighten2: '#a9e043',
          lighten3: '#ebffe6',
          lighten4: '#f8f9f5'
        }
      }
    }
  }
});
